export default "__VITE_ASSET__85960e8d__"